export default "__VITE_ASSET__CoexIAY4__"